/**
 * @generated SignedSource<<9f026c517118d15b79fd44fe3d92745f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FormulaSetUpdateInput = {
  description?: string | null;
  formulas?: ReadonlyArray<FormulaCreateInput> | null;
  id: string;
};
export type FormulaCreateInput = {
  description?: string | null;
  editor: EditorInput;
  title: EditorInput;
};
export type EditorInput = {
  text: string;
  textHtml?: string | null;
};
export type FormulaSetUpdateDialog_formulaSetUpdateMutation$variables = {
  input: FormulaSetUpdateInput;
};
export type FormulaSetUpdateDialog_formulaSetUpdateMutation$data = {
  readonly formulaSetUpdate: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"FormulaSetFormulaSetHistoryPaginator_formulaSet" | "FormulaSetMutationActionsButtonStack_formulaSet" | "FormulaSetUpdateDialog_formulaSet">;
  };
};
export type FormulaSetUpdateDialog_formulaSetUpdateMutation = {
  response: FormulaSetUpdateDialog_formulaSetUpdateMutation$data;
  variables: FormulaSetUpdateDialog_formulaSetUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "order",
    "value": {
      "created": "DESC"
    }
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "before",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "after",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormulaSetUpdateDialog_formulaSetUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormulaSet",
        "kind": "LinkedField",
        "name": "formulaSetUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FormulaSetUpdateDialog_formulaSet"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FormulaSetMutationActionsButtonStack_formulaSet"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FormulaSetFormulaSetHistoryPaginator_formulaSet"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormulaSetUpdateDialog_formulaSetUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormulaSet",
        "kind": "LinkedField",
        "name": "formulaSetUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnitD",
            "kind": "LinkedField",
            "name": "unitD",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unitATitle",
                "storageKey": null
              },
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormulaConnection",
            "kind": "LinkedField",
            "name": "formulas",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FormulaEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Formula",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "FormulaSetHistoryConnection",
            "kind": "LinkedField",
            "name": "histories",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormulaSetHistoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormulaSetHistory",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "picture",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDeleted",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "difference",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isDifference"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormulaDifference",
                                "kind": "LinkedField",
                                "name": "formulas",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Diff",
                                    "kind": "LinkedField",
                                    "name": "text",
                                    "plural": false,
                                    "selections": (v7/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Diff",
                                    "kind": "LinkedField",
                                    "name": "title",
                                    "plural": false,
                                    "selections": (v7/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "description",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "FormulaSetDifference",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "histories(first:10,order:{\"created\":\"DESC\"})"
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "filters": [
              "order"
            ],
            "handle": "connection",
            "key": "FormulaSetFormulaSetHistoryPaginator_formulaSet_histories",
            "kind": "LinkedHandle",
            "name": "histories"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a02d5048cd569d35fa1d3a025949d493",
    "id": null,
    "metadata": {},
    "name": "FormulaSetUpdateDialog_formulaSetUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation FormulaSetUpdateDialog_formulaSetUpdateMutation(\n  $input: FormulaSetUpdateInput!\n) {\n  formulaSetUpdate(input: $input) {\n    id\n    ...FormulaSetUpdateDialog_formulaSet\n    ...FormulaSetMutationActionsButtonStack_formulaSet\n    ...FormulaSetFormulaSetHistoryPaginator_formulaSet\n  }\n}\n\nfragment DiffItem_diff on Diff {\n  before\n  after\n}\n\nfragment FormulaDifferenceItemList_formulaDifference on FormulaDifference {\n  text {\n    ...DiffItem_diff\n  }\n  title {\n    ...DiffItem_diff\n  }\n}\n\nfragment FormulaSetDifferenceItemList_formulaSetDifference on Difference {\n  __isDifference: __typename\n  ... on FormulaSetDifference {\n    formulas {\n      ...FormulaDifferenceItemList_formulaDifference\n    }\n    description {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment FormulaSetFormulaSetHistoryPaginator_formulaSet on FormulaSet {\n  histories(order: {created: DESC}, first: 10) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...FormulaSetHistoryDialog_formulaSetHistory\n        ...FormulaSetHistoryTimelineItem_formulaSetHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n\nfragment FormulaSetHistoryDialog_formulaSetHistory on FormulaSetHistory {\n  createdBy {\n    name\n    picture\n    id\n  }\n  created\n  difference {\n    __typename\n    ...FormulaSetDifferenceItemList_formulaSetDifference\n  }\n}\n\nfragment FormulaSetHistoryTimelineItem_formulaSetHistory on FormulaSetHistory {\n  id\n  createdBy {\n    ...UserAvatarText_user\n    id\n  }\n  created\n  type\n}\n\nfragment FormulaSetMutationActionsButtonStack_formulaSet on FormulaSet {\n  id\n  actions\n  ...FormulaSetUpdateDialog_formulaSet\n}\n\nfragment FormulaSetStatusLabel_formulaSet on FormulaSet {\n  status\n}\n\nfragment FormulaSetUpdateDialog_formulaSet on FormulaSet {\n  id\n  description\n  unitD {\n    unitATitle\n    title\n    id\n  }\n  formulas {\n    totalCount\n    edges {\n      node {\n        title\n        text\n        id\n      }\n    }\n  }\n  ...FormulaSetStatusLabel_formulaSet\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "6e6e1aea850e0f3d7381f91995f70caa";

export default node;
